import { BookOpen, CheckCircle2, Circle, PauseCircle, RotateCcw } from 'lucide-react';
import { useSettings } from '../settings';
import { useTutorials } from './TutorialProvider';
import { findTarget } from './tutorialConfig';

function StatusIcon({ status }) {
  if (status === 'completed') return <CheckCircle2 size={16} aria-hidden="true" />;
  if (status === 'paused' || status === 'active') return <PauseCircle size={16} aria-hidden="true" />;
  return <Circle size={16} aria-hidden="true" />;
}

export default function TutorialCenter({ onBeforeStart }) {
  const { t } = useSettings();
  const {
    tutorials,
    progress,
    loaded,
    startTutorial,
    restartTutorial,
    statusLabel,
  } = useTutorials();

  const launch = (tutorial, restart = false) => {
    if (tutorial.id !== 'settings.preferences') onBeforeStart?.();
    window.setTimeout(() => {
      if (restart) restartTutorial(tutorial.id);
      else startTutorial(tutorial.id);
    }, 0);
  };

  return (
    <section className="settings-card settings-card-wide tutorial-center" data-tour="settings-tutorials" data-no-translate>
      <div className="settings-card-title">
        <BookOpen size={18} aria-hidden="true" />
        <div>
          <h3>{t('tutorial.center.title')}</h3>
          <p>{t('tutorial.center.help')}</p>
        </div>
      </div>
      {!loaded ? (
        <p className="tutorial-center-loading" role="status">{t('tutorial.center.loading')}</p>
      ) : (
        <div className="tutorial-center-list">
          {tutorials.map((tutorial) => {
            const record = progress[tutorial.id];
            const current = record?.tutorial_version === tutorial.version ? record : null;
            const status = current?.status || 'new';
            const resumable = ['paused', 'active'].includes(status);
            const available = !tutorial.requiredTarget || Boolean(findTarget(tutorial.requiredTarget));
            const actionLabel = !available
              ? t('tutorial.controls.unavailable')
              : resumable
              ? t('tutorial.controls.resume')
              : current
                ? t('tutorial.controls.replay')
                : t('tutorial.controls.start');
            return (
              <div className={`tutorial-center-row is-${status}`} key={tutorial.id}>
                <StatusIcon status={status} />
                <span>
                  <strong>{t(tutorial.titleKey)}</strong>
                  <small>{available ? statusLabel(status) : t('tutorial.center.contextRequired')}</small>
                </span>
                <button type="button" disabled={!available} onClick={() => launch(tutorial, Boolean(current && !resumable))}>
                  {current && !resumable ? <RotateCcw size={14} aria-hidden="true" /> : null}
                  {actionLabel}
                </button>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}
